import { Paper } from '@gto/ui/paper'

import { Loader } from '@/components/loader'
import { useAuth } from '@/hooks/use-auth'
import { useEdgeBalance } from '@/hooks/use-edge-balance'

import { CryptoUnlockProgress } from './crypto-unlock-progress'
import { RedemptionsTabs } from './redemptions-tabs'

export const CryptoRedemptions = () => {
  const { user } = useAuth()

  const { loading, isRedemptionUnlocked } = useEdgeBalance()
  if (!user) {
    return null
  }

  if (loading) {
    return <Loader />
  }

  return (
    <Paper
      className="mx-auto w-full max-w-[660px] rounded-md border border-divider p-8 sm:p-4 sm:pb-8"
      elevation="3"
    >
      {isRedemptionUnlocked ? <RedemptionsTabs /> : <CryptoUnlockProgress />}
    </Paper>
  )
}
